import gql from 'graphql-tag';

export default gql`
  query accountsContent($moduleName: String) {
    accountsContent(moduleName: $moduleName) {
      Status
      AcctNo
      AcctName
      AcctNote
      Level
      Focus
      Type
      Growth
      Sup
      State
      Address
      AddressOptions {
        Addr {
          text
          value
          id
        }
        Def
      }
      Wb1
      Wb1Phone
      Wb1Email
      Wb2
      Wb2Phone
      Wb2Email
      Wb3
      Wb3Phone
      Wb3Email
      Affil
      Bal
      DelNote
      Po
      Coop
      Lic
      Prem
      City
      County
      DaysPrint
      Last
      Rep
      Region
      Days
    }
  }
`;
